<button
  class="button"
  [ngClass]="buttonStyleClass"
>
</button>
